import { useState, useRef, useEffect } from "react";
import { Button } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import CustomSelect from '../Compartido/CustomSelect.jsx';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import nl from 'date-fns/locale/nl';
import ru from 'date-fns/locale/ru';
import it from 'date-fns/locale/it';
import pt from 'date-fns/locale/pt';
import cs from 'date-fns/locale/cs';
import axios from 'axios';
import usePreciosCalendario from '../Compartido/usePreciosCalendario.js';
import useHorizontalCarousel from '../Compartido/useHorizontalCarousel.js';
import textosCamprodon, { RUTA_IMATGES, rutaPagina } from '../Compartido/contenidoCamprodon.js';

import { useTranslation } from 'react-i18next';

const Banner = ({ destinos, lang, ruta, d_ale, config, capacidad_maxima, noninos, elementosweb }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    // 'yyyy-MM-dd' local (no toISOString: evita el desfase per zona horària),
    // mateixa clau que retorna PaginasController::preciosBuscadorGeneral.
    const fechaAPreciosKey = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    // Preus carregats a poc a poc (2 mesos cada cop) a mida que es navega
    // el calendari, en comptes de calcular-ho tot (totes les propietats
    // de la web x molts mesos) a la càrrega de la home.
    const { preciosPorDia, cargandoPrecios, carregarPreusMes } = usePreciosCalendario('/preciosbuscadorgeneral');

    const { t } = useTranslation();

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else if (lang == "nl")
        registerLocale('nl', nl)
    else if (lang == "ru")
        registerLocale('ru', ru)
    else if (lang == "pt")
        registerLocale('pt', pt)
    else if (lang == "it")
        registerLocale('it', it)
    else if (lang == "cs")
        registerLocale('cs', cs)
    else
        registerLocale('es', es)



    const toggleBlur = (shouldBlur) => {
        var elements = document.getElementsByClassName("potblur");
        if (shouldBlur) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.add('blur');
            }
        } else {
            for (var i = 0; i < elements.length; i++) {
                elements[i].classList.remove('blur');
            }
        }
    };

    let results3 = [];

    const [results4, setResults4] = useState(null);

    const numpersonas = useRef(null);

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    const [show, setShow] = useState('none');
    const handleShow = () => {
        if (show == 'none') {
            setShow('block');
            toggleBlur(true);
        }
        else {
            setShow('none');
            toggleBlur(false);
        }
    };

    const formpersonasRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const dropdown = formpersonasRef.current;
            const trigger = numpersonas.current;

            if (dropdown && !dropdown.contains(event.target) &&
                trigger && !trigger.contains(event.target)) {
                setShow('none');
            }
        };

        // Agregar el event listener
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Limpiar el event listener
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    let objeto0 = { id: -1, name: t("Todos"), value: "" }

    const buscabarrios = (destino) => {
        if (destino) {
            let token = document.getElementById('meta_token').getAttribute('content');

            const result = axios.post('/busca-barrios', {
                destino: destino
            }, {
                headers: {
                    'content-type': 'text/json',
                    'X-CSRF-TOKEN': token
                }
            })
                .then((response) => {
                    setResults4(null);
                    let resultsbarrios = [];
                    if (response.data.length > 0) {
                        {
                            response.data.forEach((unbarrio, index) => {
                                let objeto = { id: index, name: unbarrio.elnombre, value: unbarrio.id }
                                resultsbarrios = resultsbarrios.concat(objeto);
                            })
                        }
                        setResults4(resultsbarrios);
                    }
                })
        }
        else {
            setResults4(null);
        }
    }

    results3 = results3.concat(objeto0);
    {
        destinos.forEach((undestino, index) => {
            let objeto = { id: index, name: undestino.elnombre, value: undestino.laurl }
            results3 = results3.concat(objeto);
        })
    }

    // Si la web només té un destí, el cercador el mostra triat per defecte.
    const destiDefecte = destinos.length === 1 ? destinos[0] : null;

    const [titlePersonas] = useState(t("Personas"));

    {/* ******************* */ }

    // Una o més habitacions, cadascuna amb els seus propis adults/nens.
    // Només és una manera més còmoda d'introduir els números — per sota
    // se segueix enviant un sol adultos/ninos (la suma de totes les
    // habitacions) exactament igual que abans, cap canvi al cercador ni
    // al backend.
    const [habitaciones, setHabitaciones] = useState([{ adultos: 1, ninos: 0 }]);

    const countAdults = habitaciones.reduce((total, hab) => total + hab.adultos, 0);
    const countNinos = habitaciones.reduce((total, hab) => total + hab.ninos, 0);

    const cambiarHabitacion = (index, campo, delta) => {
        setHabitaciones(prev => prev.map((hab, i) => {
            if (i !== index) return hab;
            const nuevoValor = hab[campo] + delta;
            if (campo === 'adultos' && nuevoValor < 1) return hab;
            if (campo === 'ninos' && nuevoValor < 0) return hab;
            const otroValor = campo === 'adultos' ? hab.ninos : hab.adultos;
            if (nuevoValor + otroValor > capacidad_maxima) return hab;
            return { ...hab, [campo]: nuevoValor };
        }));
    };

    const anadirHabitacion = () => {
        setHabitaciones(prev => [...prev, { adultos: 1, ninos: 0 }]);
    };

    const eliminarHabitacion = (index) => {
        setHabitaciones(prev => prev.length > 1 ? prev.filter((_, i) => i !== index) : prev);
    };

    // Etiqueta del desplegable tancat: recalculada sola cada cop que
    // canvia qualsevol habitació, en comptes de cridar-la a mà des de
    // cada handler (evitava haver-la de repetir i el risc de quedar-se
    // amb un valor vell si dos canvis es solapaven).
    useEffect(() => {
        let frase = t("Escoja personas");
        if (countAdults == 1) frase = " " + countAdults + " " + t("Adulto");
        if (countAdults > 1) frase = " " + countAdults + " " + t("Adultos");
        if (countNinos == 1) frase += " " + countNinos + " " + t("Niño");
        if (countNinos > 1) frase += " " + countNinos + " " + t("Niños");
        if (habitaciones.length > 1) frase += " · " + habitaciones.length + " " + t("Habitaciones");

        if (numpersonas.current) numpersonas.current.textContent = frase;
    }, [countAdults, countNinos, habitaciones.length]);

    const handleFocus = (e) => {
        const { target } = e;

        if (target) {
            target.readOnly = true;  // -------> this for all others
            target.blur(); //  ------> this for ios iphone
        }
    };

    const [cMeses, setCMeses] = useState(2);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1023);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            setCMeses(1);
        }
        else {
            setCMeses(2);
        }
    }, [isMobile, cMeses]);

    // Barra fixa a peu de pàgina + popup a pantalla completa, només a
    // mòbil (el cercador flotant de desktop es queda amagat aleshores,
    // veure inicio.css). El mateix <form> d'abans, només es mostra/amaga
    // amb aquesta classe extra.
    const [sheetOpen, setSheetOpen] = useState(false);

    const textos = textosCamprodon(lang);

    // Slider del hero (tiny-slider a l'original): dues fotos en bucle.
    const slides = [
        { ...textos.hero[0], titulo: elementosweb?.subtitulo_buscador?.[lang] || textos.hero[0].titulo, imatge: "hero-fachada" },
        { ...textos.hero[1], imatge: "hero-bar", boton: { href: rutaPagina("servicios", lang), label: t("Descubre más") } },
    ];
    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.c-hero__slide', slides.length);
    const canviaSlide = (delta) => {
        const pista = trackRef.current;
        if (delta > 0 && navState.atEnd) pista.scrollTo({ left: 0, behavior: 'smooth' });
        else if (delta < 0 && navState.atStart) pista.scrollTo({ left: pista.scrollWidth, behavior: 'smooth' });
        else scrollByCard(delta);
    };

    // Resum del cercador per a la barra fixa de mòbil (com a bedloophotel).
    const resumFechas = () => {
        if (!startDate) return t("Elige fechas");
        const opciones = { day: 'numeric', month: 'short' };
        const inicio = startDate.toLocaleDateString(lang, opciones);
        if (!endDate) return inicio;
        const final = endDate.toLocaleDateString(lang, opciones);
        return inicio + ' - ' + final;
    };

    const resumPersonas = () => countAdults + countNinos;

    {/* ******************* */ }

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{ maxHeight: "100vh" }}>
                    <div className="c-hero__slider hc-js-slider" ref={trackRef}>
                            {slides.map((slide, index) => (
                                <div className="c-hero__slide position-relative" key={index}>
                                    <picture>
                                        <source srcSet={RUTA_IMATGES + slide.imatge + ".webp"} media="(min-width: 768px)" type="image/webp" />
                                        <source srcSet={RUTA_IMATGES + slide.imatge + "-movil.webp"} type="image/webp" />
                                        <img
                                            src={RUTA_IMATGES + slide.imatge + ".jpg"}
                                            alt={slide.titulo}
                                            className="image-cover image-full c-hero__image"
                                            width="100%"
                                            height="100%"
                                            loading={index === 0 ? "eager" : "lazy"}
                                            decoding="async"
                                        />
                                    </picture>
                                    <div className="c-hero__content position-relative">
                                        <span className="c-hero__small-title text-uppercase">{slide.antetitulo}</span>
                                        <div className="c-hero__title">{slide.titulo}</div>
                                        {slide.boton && (
                                            <a href={slide.boton.href} className="c-button c-button--secondary text-uppercase">{slide.boton.label}</a>
                                        )}
                                        <span className="line max-line-height"></span>
                                        <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                            <use href={RUTA_IMATGES + "icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"}></use>
                                        </svg>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className="c-hero-controls d-inline-flex">
                        <button type="button" className="c-hero-controls__button c-hero-controls__prev" aria-label={t("Anterior")} onClick={() => canviaSlide(-1)}></button>
                        <button type="button" className="c-hero-controls__button" aria-label={t("Siguiente")} onClick={() => canviaSlide(1)}></button>
                    </div>
                </div>
            </section>

            {/* Cercador de bedloophotel: caixa blanca flotant al peu de la
                finestra a escriptori; a mòbil, barra fixa que l'obre a
                pantalla completa. */}
            <button type="button" className="bh-mobile-trigger" onClick={() => setSheetOpen(true)}>
                <span className="bh-mobile-trigger__resum">
                    <i className="fa-solid fa-calendar-days"></i> {resumFechas()}
                    <span className="bh-mobile-trigger__separador"></span>
                    <i className="fa-solid fa-user-group"></i> {resumPersonas()}
                </span>
                <span className="bh-mobile-trigger__cta" style={{ background: config.color_corporativo_web }}>
                    <i className="fa-solid fa-magnifying-glass"></i> {t("Buscar")}
                </span>
            </button>

            {sheetOpen && <div className="bh-mobile-backdrop" onClick={() => setSheetOpen(false)}></div>}

        <div className={"container fondo-buscador caixa-home bhh-search bh-mobile-sheet" + (sheetOpen ? " bh-mobile-sheet--open" : "")}>
            <div className="bh-mobile-sheet__header">
                <span>{t("Buscar")}</span>
                <button type="button" className="bh-mobile-sheet__close" onClick={() => setSheetOpen(false)} aria-label={t("Cerrar")}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>
            {/* PENDENT DE FER */}
            {/* {elementosweb.cabecera_buscador && <h5 className="text-center">{elementosweb.cabecera_buscador[lang]}</h5>} */}
            <form method="get" action={"/" + preidioma + t("buscar2")}>
                <div className="row">
                    <div className="col buscador-inputs bderecha bhh-search__col-destino">
                        <span className="titulobuscador"><i className="fa-solid fa-location-dot bhh-search__icon"></i>{t("Destinos")}</span>
                        <CustomSelect
                            defaultText={destiDefecte ? destiDefecte.elnombre : "Todos"}
                            realInput={destiDefecte ? destiDefecte.laurl : undefined}
                            optionsList={results3}
                            nameInput="destino"
                            funcion={buscabarrios}
                            onOpen={() => toggleBlur(true)}
                            onClose={() => toggleBlur(false)}
                        />
                    </div>
                    {results4 && (
                        <div className="col buscador-inputs bderecha bhh-search__col-barrio">
                            <span className="titulobuscador"><i className="fa-solid fa-map bhh-search__icon"></i>{t("Barrios")}</span>
                            <CustomSelect
                                defaultText="Todos"
                                optionsList={results4}
                                nameInput="barrio"
                                onOpen={() => toggleBlur(true)}
                                onClose={() => toggleBlur(false)}
                            />
                        </div>
                    )}

                    <div className="col buscador-inputs bderecha bhh-search__col-fechas">
                        <span className="titulobuscador"><i className="fa-solid fa-calendar-days bhh-search__icon"></i>{t("Entrada - Salida")}</span>
                        <DatePicker
                            isClearable={true}
                            onChange={(update) => {
                                setDateRange(update);
                            }}
                            onCalendarOpen={() => {
                                toggleBlur(true);
                                carregarPreusMes(startDate || new Date(), cMeses);
                            }}
                            onCalendarClose={() => toggleBlur(false)}
                            onMonthChange={(date) => carregarPreusMes(date, cMeses)}
                            className="form-control cpointer noborder fs15"
                            autoComplete="off"
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange={true}
                            monthsShown={cMeses}
                            dateFormat="dd/MM/yyyy"
                            minDate={new Date()}
                            placeholderText={t("DD/MM/YYYY - DD/MM/YYYY")}
                            locale={lang}
                            name="daterange"
                            onFocus={handleFocus}
                            popperPlacement={sheetOpen ? "bottom" : "top"}
                            popperModifiers={[
                                {
                                    name: "flip",
                                    options: {
                                        fallbackPlacements: [sheetOpen ? "bottom" : "top"],
                                        allowedAutoPlacements: [sheetOpen ? "bottom" : "top"],
                                    },
                                },
                            ]}
                            renderDayContents={(day, date) => {
                                const precio = preciosPorDia[fechaAPreciosKey(date)];
                                return (
                                    <>
                                        {day}
                                        <small className="bh-precio-dia-picker">
                                            {precio > 0
                                                ? Math.round(precio / 100) + '€'
                                                : cargandoPrecios
                                                    ? <span className="bh-precio-dia-picker__spinner"></span>
                                                    : ' '}
                                        </small>
                                    </>
                                );
                            }}
                            calendarContainer={({ className, children }) => (
                                <div className={className}>
                                    {cargandoPrecios && (
                                        <div className="bh-precios-spinner" aria-live="polite">
                                            <span className="bh-precios-spinner__dot"></span>
                                            {t("Cargando precios")}...
                                        </div>
                                    )}
                                    {children}
                                </div>
                            )}
                        >
                        </DatePicker>
                    </div>

                    <div className="col buscador-inputs bhh-search__col-personas">
                        <span className="titulobuscador"><i className="fa-solid fa-user-group bhh-search__icon"></i>{t("Huéspedes")}</span>
                        <div onClick={handleShow} className="form-control numpersonas mw201 noborder" ref={numpersonas}> 1 {t("Adulto")}</div>
                        {/* ********* */}

                        <div className={"formpersonas" + (habitaciones.length > 3 ? " formpersonas--horizontal" : "")} style={{ display: show }} onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget)) { setShow("none"); toggleBlur(false); } }} tabIndex="0" onMouseLeave={handleShow} ref={formpersonasRef}>

                            <div className={"bh-habitaciones" + (habitaciones.length > 3 ? " bh-habitaciones--horizontal" : "")}>
                            {habitaciones.map((habitacion, index) => (
                                <div className="bh-habitacion" key={index}>
                                    {habitaciones.length > 1 && (
                                        <div className="bh-habitacion__header">
                                            <span className="bh-habitacion__titol">{t("Habitación")} {index + 1}</span>
                                            <button type="button" className="bh-habitacion__eliminar" onClick={() => eliminarHabitacion(index)}>
                                                {t("Eliminar habitación")}
                                            </button>
                                        </div>
                                    )}

                                    <div className="mt-2 row">
                                        <label className="col-md-6 col-6 etiqueta-formulari">
                                            {t("Adultos")}
                                            <div className="mini-etiqueta-formulari">({t("Desde_12_años")})</div>
                                        </label>
                                        <div className="col-md-4 col-6">
                                            <div className="mt-4 input-group">
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn btn-xs btn-number boto-cercle" onClick={() => cambiarHabitacion(index, 'adultos', -1)}>
                                                        <span className="centrar-boto-cercle">
                                                            <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                        </span>
                                                    </button>
                                                </span>
                                                <input type="text" className="form-control input-number numero-persones" value={habitacion.adultos} readOnly={true} />
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn btn-xs btn-number boto-cercle" onClick={() => cambiarHabitacion(index, 'adultos', 1)}>
                                                        <span className="centrar-boto-cercle">
                                                            <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }} >
                                                                <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                            </svg>
                                                        </span>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {noninos == 0 && (
                                        <>
                                            <div className="linia"></div>

                                            <div className="mt-3 row">
                                                <label className="col-md-6 col-6 etiqueta-formulari"> {t("Niños")}<div className="mini-etiqueta-formulari">({t("De_2_a_12_años")})</div></label>
                                                <div className="mt-2 col-md-4 col-6">
                                                    <div className="mt-3 input-group">
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-xs btn-number boto-cercle" type="button" onClick={() => cambiarHabitacion(index, 'ninos', -1)}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                        <input type="text" className="form-control input-number numero-persones" value={habitacion.ninos} readOnly={true} />
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-xs btn-number boto-cercle" type="button" onClick={() => cambiarHabitacion(index, 'ninos', 1)}>
                                                                <span className="centrar-boto-cercle">
                                                                    <svg viewBox="0 0 24 24" role="img" aria-label="add" focusable="false" style={{ height: "1em", width: "1em", display: "block", fill: "currentcolor" }}>
                                                                        <rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect>
                                                                    </svg>
                                                                </span>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                </div>
                            ))}
                            </div>

                            <input type="hidden" name="adultos" value={countAdults} />
                            <input type="hidden" name="ninos" value={countNinos} />

                            <input type="hidden" name="bebes" value="0" />
                            <input type="hidden" name="distribucion" value={habitaciones.map(h => h.adultos + "-" + h.ninos).join(";")} />

                            <div className="linia"></div>

                            <button type="button" className="bh-anadir-habitacion" onClick={anadirHabitacion}>
                                <i className="fa-solid fa-plus"></i> {t("Añadir habitación")}
                            </button>
                        </div>

                        {/* ********* */}
                    </div>
                    <div className="col buscador-inputs botonsubmit">
                        <Button variant="primary" size="md" type="submit" style={{ background: "" + config.color_corporativo_web + "", border: "1px solid" + config.color_corporativo_web, borderRadius: "0", height: "100%", marginTop: "0" }} className="submit-button-custom bhh-cta">
                            <span className="onlymobile">{t("Buscar")} </span><i className="fa-solid fa-magnifying-glass fs21"></i>
                        </Button>
                    </div>
                </div>
            </form>
        </div>
        </>
    );
}

export default Banner;
